const samesite = window.SS_GLOBALS.forceSSL ? 'none' : 'lax';

export default {
  secure: window.SS_GLOBALS.forceSSL,
  samesite: samesite
};
